export default class Logger {
  name: string

  constructor(name: string) {
    this.name = name
  }

  debug(...args: unknown[]) {
    console.debug(`%c[${this.name}]`, 'color: blue', ...args)
  }

  info(...args: unknown[]) {
    console.info(`%c[${this.name}]`, 'color: green', ...args)
  }

  warn(...args: unknown[]) {
    console.warn(`%c[${this.name}]`, 'color: orange', ...args)
  }

  error(...args: unknown[]) {
    console.error(`%c[${this.name}]`, 'color: red', ...args)
  }
}
